import React from 'react';

//import './style.css';
import 'primereact/resources/themes/saga-blue/theme.css';

import './layout.scss';

const Theme = () => (<React.Fragment></React.Fragment>);

export default Theme;